/** Margin Signals: profit leaking between cost and price - purchase prices
 *  that rose while selling prices did not, items sold below cost, margin by
 *  branch, customers whose margin fell (backend/chainlit/margin_engine.py).
 *  The page itself is EnginePage. */
import EnginePage from '@/components/engine/EnginePage';
import { MARGIN_API } from '@/components/engine/api';

export default function MarginEngine() {
  return (
    <EnginePage
      api={MARGIN_API}
      eyebrow="Margin Signals"
      fallbackTitle="Margin Signals: profit leaking between cost and price"
    />
  );
}
